import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {LocalStorageUtils} from "../../../infrastructure/utils/local-storage.utils";
import {LOCAL_STORAGE_KEYS} from "../../../core/consts";
import {WebsiteModuleState} from "../models/website-module.state";
import {CookieManager} from "../../../core/managers/cookie-manager";
import {LanguageViewModel} from "../../../domain/locale/models/language/language.view-model";
import {LocaleDomainService} from "../../../domain/locale/services/locale/locale.domain-service";
import {WEBSITE_MODULE} from "../website-module.consts";
import {LanguageDomainModel} from "../../../domain/locale/models/language/language.domain-model";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {WebsiteModuleUsPopupDisplayEvent} from "../models/website-module.us-popup.display-event";
import {WebsiteModuleUsPopupClickEvent} from "../models/website-module.us-popup.click-event";
import {UserAgentViewModel} from "../../../core/models/user-agent.view-model";

export class WebsiteModuleUsPopupHandler extends ActionHandler {
  localStorageUtils: LocalStorageUtils;
  cookieManager: CookieManager;
  localeDomainService: LocaleDomainService;
  analyticsService: AnalyticsService;
  state: WebsiteModuleState;
  type = WEBSITE_MODULE.ACTION_TYPES.usPopup;

  static injectables = [LocalStorageUtils, CookieManager, LocaleDomainService, AnalyticsService, UserAgentViewModel];

  constructor(
    localStorageUtils: LocalStorageUtils,
    cookieManager: CookieManager,
    localeDomainService: LocaleDomainService,
    analyticsService: AnalyticsService,
    userAgentViewModel: UserAgentViewModel
  ) {
    super();

    this.localStorageUtils = localStorageUtils;
    this.cookieManager = cookieManager;
    this.localeDomainService = localeDomainService;
    this.analyticsService = analyticsService;
    this.userAgentViewModel = userAgentViewModel;
  }

  onLoaded() {
    super.onLoaded();

    const usPopupResponse = this.localStorageUtils.get(LOCAL_STORAGE_KEYS.usPopupResponse);
    const isVisibleNyStorageFlag = usPopupResponse === undefined;
    // const isUsUser: Boolean = this.appStore.state.locale?.userCountryId === WEBSITE_MODULE.US_USER_COUNTRY;
    const isUSLocalDataLanguage = this.cookieManager.localDataCookie.defaultLangID === WEBSITE_MODULE.US_LANGUAGE_ID;
    const currentLangId = this.localeDomainService.locale?.language.id
    const isDefaultLang: Boolean = !this.cookieManager.userSettingsCookie.selectedLangID && currentLangId === WEBSITE_MODULE.DEFAULT_LANGUAGE_ID;
    const isCampaignLink = this.appStore.state.appBettingPromotionDisplayModel.isCampaignLink;

    if (isVisibleNyStorageFlag && isUSLocalDataLanguage && isDefaultLang && !this.userAgentViewModel.isPrerender && !isCampaignLink) {
      this.state.isUSPopupVisible = true;
      this._displayEvent();
    }
  }

  action(params) {
    this._clickEvent(params.userAgree);

    if (params.userAgree) {
      const usLangDomain: LanguageDomainModel = this.localeDomainService.languages?.find((language: LanguageViewModel) => language.id === WEBSITE_MODULE.US_LANGUAGE_ID);
      const usLangVM: LanguageViewModel = new LanguageViewModel(usLangDomain, this.navigationManager);
      this.cookieManager.updateCookieLangId(usLangVM.id);
      this.navigationManager.gotoUrl(usLangVM.linkModel.url);
    }

    this.state.isUSPopupVisible = false;
    this.localStorageUtils.set(LOCAL_STORAGE_KEYS.usPopupResponse, params.userAgree);
  }

  _displayEvent() {
    const displayEvent: WebsiteModuleUsPopupDisplayEvent = new WebsiteModuleUsPopupDisplayEvent();

    this.analyticsService.createEvent(displayEvent);
  }

  _clickEvent(userAgree: Boolean) {
    const params = {
      clickType: userAgree ? WEBSITE_MODULE.ANALYTICS.CLICK_TYPES.yes : WEBSITE_MODULE.ANALYTICS.CLICK_TYPES.no
    }

    const clickEvent: WebsiteModuleUsPopupClickEvent = new WebsiteModuleUsPopupClickEvent(params);

    this.analyticsService.createEvent(clickEvent);

  }
}
